/**
 * Layer Mapping Preset Service
 *
 * 현장(site project) 단위로 공유되는 DXF 레이어 매핑 프리셋의 저장/조회.
 */

import { createAuthenticatedClient } from './api/apiClient';
import type { LayerMappingEntry, LayerMappingPreset } from '../models/LayerMappingPreset';

const api = createAuthenticatedClient();

interface ApiEnvelope<T> {
  success: boolean;
  message?: string;
  data?: T;
}

export class LayerMappingPresetService {
  static async list(siteProjectId: number): Promise<LayerMappingPreset[]> {
    const response = await api.get<ApiEnvelope<LayerMappingPreset[]>>(
      `/v0.1/site-projects/${siteProjectId}/layer-mapping-presets`
    );
    if (!response.data?.success) {
      throw new Error(response.data?.message || '레이어 매핑 프리셋 조회에 실패했습니다.');
    }
    return response.data.data ?? [];
  }

  static async create(
    siteProjectId: number,
    name: string,
    mappings: LayerMappingEntry[]
  ): Promise<LayerMappingPreset> {
    const response = await api.post<ApiEnvelope<LayerMappingPreset>>(
      `/v0.1/site-projects/${siteProjectId}/layer-mapping-presets`,
      { name, mappings }
    );
    if (!response.data?.success || !response.data.data) {
      throw new Error(response.data?.message || '레이어 매핑 프리셋 저장에 실패했습니다.');
    }
    return response.data.data;
  }
}
